import * as React from "react";
import moment from "moment";

import {dateFormat} from "@/utils/constants";

import "./index.scss";

export default function ScoutingStaffCard(props) {
	const {element} = props;

	const name = element.firstName
		? element.firstName + " " + element.lastName
		: element.lastName;

	return (
		<div className="scout-coach-card-container">
			<div className="scout-coach-card-header">
				<div className="top-left">
					{element.dateOfBirth && moment(element.dateOfBirth)?.year() > 1900
						? moment(element.dateOfBirth).format(dateFormat)
						: "---"}
				</div>
				<div className="top-right">{"Area " + element.unit}</div>
			</div>
			<div className="scout-coach-card-info">
				<div className="info-title">{name}</div>
				<div className="info-subtitle">{element.role}</div>
			</div>
		</div>
	);
}
